import TheDartsGame from './theDartsGame/TheDartsGame'
import TheCellarDoor from './TheCellarDoor'
import ThePokerBoard from './ThePokerBoard'
import TheCashRegister from './theCashRegister/TheCashRegister'
import TheBarrels from './TheBarrels'
import TheDice from './TheDice'
import TheDirectionalPad from './theDirectionalPad/TheDirectionalPad'
import Jack from './Jack'
import TheSafe from './theSafe/TheSafe'

import barrelProcess from '../../../../images/clues/fourJokers/barrelProcess.png'
import barrelProcess2 from '../../../../images/clues/fourJokers/barrelProcess2.png'
import barrelSolution from '../../../../images/clues/fourJokers/barrelSolution.png'

import diceProcess from '../../../../images/clues/fourJokers/diceProcess.png'
import safeProcess from '../../../../images/clues/fourJokers/safeProcess.png'


const fourJokersData = [
    {
        name: 'The Darts Game',
        id: 'darts',
        sceneText: "Jack is always playing games... today it's darts",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheDartsGame />,
        cluesAvailable: true,
        clues: [
            {
                text: "Use page 6 to find out Jack's score and where to aim to beat him. Make sure you don't go bust. If you request further hints Jack's score will be lowered."
            },
            {
                text: "Jack's score has been lowered to 65."
            },
            {
                text: "Jack's score has been lowered to 60."
            },
            {
                text: "Jack's score has been lowered to 55."
            },
            {
                text: "Jack's score has been lowered to 35. If you request another hint Jack's score will be reduced to 0."
            },
            {
                text: "Jack's score has been reduced to 0. Get a score between 1 and 100 to pass Jack's game."
            }
        ]
    },
    {
        name: 'The Cellar Door',
        id: 'cellarDoor',
        sceneText: "Door to the cellar, locked up tight",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheCellarDoor />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Use page 3 to work out the code for the cellar door.'
            },
            {
                text: 'You need to fill in the squares on page 3 with the name of the poker champion. Can you find anything in the Four Jokers to tell you who that is?'
            },
            {
                text: "Ma 'Sidewalk' Lydor is the poker champion. Can you work out on page 3 why M to S equals 6?",
            },
            {
                text: "The letter S is 6 letters after M in the alphabet. The next hint will be the solution.",
            },
            {
                text: 'The code for the cellar door is: 72337.'
            }
        ]
    },
    {
        name: 'The Poker Board',
        id: 'pokerBoard',
        sceneText: "The poker championship leaderboard",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <ThePokerBoard />,
        cluesAvailable: false
    },
    {
        name: 'The Cash Register',
        id: 'cashRegister',
        sceneText: "A cash register, but is there any cash inside?",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheCashRegister />,
        cluesAvailable: false
    },
    {
        name: 'The Barrels',
        id: 'barrels',
        sceneText: "An open door down to the cellar",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheBarrels />,
        cluesAvailable: false,
        clues: [
            {
                text: 'The barrels will help you with the cash register. Can you use the examples on page 15 to translate the barrels?'
            },
            {
                text: 'The top & bottom patterns give the top & bottom of the cash register input. Here is the first example barrel from page 15.',
                image: barrelProcess
            },
            {
                text: 'Here are the examples from page 15. The next hint will be the solution.',
                image: barrelProcess2
            },
            {
                text: 'The barrels in the cellar translate into this cash register input',
                image: barrelSolution
            }
        ]
    },
    {
        name: 'The Directional Pad',
        id: 'directionalPad',
        sceneText: "A hidden panel of directional buttons",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheDirectionalPad />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Page 3 will help you with the directional buttons. Can you find anything else in the Four Jokers to help with the order?'
            },
            {
                text: 'Check out the dice in the Four Jokers. Each roll of the dice gives you a different direction.'
            },
            {
                text: 'The sum of each dice roll in the Four Jokers is one of these numbers. The next hint will be the solution.',
                image: diceProcess
            },
            {
                text: 'Press the directional buttons in this order: LEFT - RIGHT - DOWN - UP - LEFT - RIGHT.'
            }
        ]
    },
    {
        name: 'The Dice',
        id: 'dice',
        sceneText: "Roll the dice, it's your lucky day",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheDice />,
        cluesAvailable: false
    },
    {
        name: 'The Safe',
        id: 'safe',
        sceneText: "A safe hidden behind the mirror",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheSafe />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Page 14 will help you with the safe combination.'
            },
            {
                text: 'Each coloured bottle gives you a number on page 14. Look at the bottles in the Four Jokers. Can you use them to work out the safe combination?'
            },
            {
                text: 'The brown bottle in the Four Jokers is your first number. Page 14 says this is number 2. Follow the arrow to the next bottle.',
                image: safeProcess
            },
            {
                text: 'The order of the bottles in the Four Jokers are: BEER - GROG - VODKA - GIN - RUM - WINE. Use page 14 to turn these drinks into numbers. The next hint will be the solution.'
            },
            {
                text: 'The safe combination is: 215746'
            }
        ]
    },
    {
        name: 'Speak To Jack',
        id: 'jack',
        specialIcon: 'fas fa-user-secret',
        sceneText: "if you don't have the camera then Jack doesn't want to talk",
        puzzleVisible: false,
        puzzleLocked: true,
        component: <Jack finalPuzzle />,
        cluesAvailable: false
    },
    {
        name: 'Jack',
        id: 'cameraJack',
        specialIcon: 'fas fa-user-secret',
        sceneText: "if you don't have the camera then Jack doesn't want to talk",
        puzzleVisible: false,
        puzzleLocked: true,
        component: <Jack finalPuzzle />,
        cluesAvailable: false,
        clues: [
            {
                text: "Click on the camera in your inventory and select Jack's icon in the Four Jokers."
            }
        ]
    },
    
]

export default fourJokersData